import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GalleryMain } from "./components/gallery/GalleryMain";
import { AdminGallery } from "./components/admin/AdminGallery";
import { HeaderPreview } from "./components/gallery/HeaderPreview";
import { Unwrap } from "./components/gallery/Unwrap";
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<GalleryMain />} />
        <Route path="/admin" element={<AdminGallery />} />
        <Route path="/header-preview" element={<HeaderPreview />} />
        <Route path="/unwrap" element={<Unwrap />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
